/**
 * Full Width Slider - Vertical Scroll Slider with Pinning
 */

(function () {
  "use strict";

  function initFullWidthSlider() {
    // Only initialize on desktop (768px and above)
    if (window.innerWidth < 768) {
      return;
    }

    const blocks = document.querySelectorAll(".full-width-slider");

    blocks.forEach((block) => {
      if (!window.gsap || !window.ScrollTrigger) return;

      // Find the full_wrapper parent
      const wrapper = block.closest(".full_wrapper");
      if (!wrapper) return;

      const slides = block.querySelectorAll(".slide");
      const blockId = block.getAttribute("id");
      const navigation = wrapper.querySelector(
        `.slider-navigation[data-slider-id="${blockId}"]`
      );
      const navDots = navigation ? navigation.querySelectorAll(".nav-dot") : [];

      if (slides.length === 0) return;

      // Setup z-index (higher index = higher z-index so they slide over)
      slides.forEach((slide, i) => {
        slide.style.zIndex = i + 1;
      });

      // Hide all content initially (but not in WordPress admin/editor)
      const isAdmin =
        document.body.classList.contains("wp-admin") ||
        document.body.classList.contains("block-editor-page") ||
        window.location.href.includes("/wp-admin/");

      // Track current slide for animations
      let currentSlideIndex = -1;

      // Create a single timeline with all slide animations
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: block,
          start: "top top",
          markers: false,
          end: () => `+=${slides.length * window.innerHeight}`,
          pin: true,
          scrub: true,
          onEnter: () => {
            // Show navigation when block enters viewport
            if (navigation) navigation.classList.add("active");
            // Animate first slide content
            if (currentSlideIndex !== 0) {
              //animateSlideContent(slides[0]);
              currentSlideIndex = 0;
            }
          },
          onLeave: () => {
            // Hide navigation when block leaves viewport
            if (navigation) navigation.classList.remove("active");
          },
          onEnterBack: () => {
            // Show navigation when scrolling back into view
            if (navigation) navigation.classList.add("active");
          },
          onLeaveBack: () => {
            // Hide navigation when scrolling back out
            if (navigation) navigation.classList.remove("active");
          },
          onUpdate: (self) => {
            // Update active dot and animate slide content
            const rawProgress = self.progress * slides.length;

            // Determine current slide more accurately
            let current;
            if (rawProgress >= slides.length - 1) {
              // Last 25% = last slide
              current = slides.length - 1;
            } else {
              current = Math.floor(rawProgress);
            }

            navDots.forEach((dot, i) => {
              dot.classList.toggle("active", i === current);
            });

            // Trigger animation when slide changes
            if (current !== currentSlideIndex && current >= 0) {
              //animateSlideContent(slides[current]);
              currentSlideIndex = current;
            }
          },
        },
      });

      // Add each slide animation to timeline
      slides.forEach((slide, i) => {
        if (i === 0) return; // Skip first slide

        // Start each slide from bottom (100%) and animate to top (0%)
        tl.fromTo(
          slide,
          { yPercent: 100 },
          { yPercent: 0, ease: "none", duration: 1 },
          i - 1 // Position in timeline
        );
      });

      // Navigation clicks
      navDots.forEach((dot, i) => {
        dot.addEventListener("click", () => {
          const scrollY = block.offsetTop + i * window.innerHeight;
          window.scrollTo({ top: scrollY, behavior: "smooth" });
        });
      });

      console.log("[SLIDER] Initialized with", slides.length, "slides");
    });
  }

  // Initialize slider first, then signal that it's ready
  function initSlider() {
    setTimeout(() => {
      initFullWidthSlider();
      // Signal that slider is initialized
      document.dispatchEvent(new CustomEvent("sliderInitialized"));
    }, 100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSlider);
  } else {
    initSlider();
  }

  // Re-initialize on window resize if crossing the 768px threshold
  let isDesktop = window.innerWidth >= 768;
  window.addEventListener("resize", () => {
    const nowDesktop = window.innerWidth >= 768;
    if (nowDesktop !== isDesktop) {
      isDesktop = nowDesktop;
      // Only re-init if switching to desktop
      if (nowDesktop) {
        initSlider();
      }
    }
  });
})();
